import { AutoComplete } from '~/components';
import Fuse from 'fuse.js';
import _ from 'lodash';
import React from 'react';

function CreditNoteProjectSelect({ options = [], ...props }) {
  const handleSearch = (q) => {
    if (!q) {
      return options;
    }

    const term = q.toLowerCase();
    const exactMatches = options.filter((o) => o.code?.toLowerCase().includes(term));
    const fuse = new Fuse(options, { keys: ['name'], threshold: 0.4 });
    const results = fuse.search(q);
    return _.uniq([...exactMatches, ...results.map((result) => result.item)]);
  };

  return (
    <AutoComplete
      materialPlaceholder="Project"
      placeholder="All"
      materialAlwaysVisible
      defaultOptions={options}
      renderOption={(option) => option.name}
      displayText={props.value?.name || ''}
      onSearch={handleSearch}
      {...props}
    />
  );
}

export default CreditNoteProjectSelect;
